module.exports = __webpack_public_path__ + "img/ic_vip.a8e0fe43.png";